import { createEvent, restore } from 'effector';

// * events
export const setQuestionEvent = createEvent<string>();
export const setPlaceholderEvent = createEvent<string>();

// * stores
export const $question = restore(setQuestionEvent, '');
export const $placeholder = restore(setPlaceholderEvent, '');
